import React, { useEffect, useState } from 'react';
import { Page } from '../../components';
import { FaPlus, FaMinus } from 'react-icons/fa';
import bannerImage from './imgs/HeaderGraphic.png';
import missionImage from './imgs/MissionGraphic.png';
import coleen from './imgs/coleen.png';
import coleenImg from './imgs/MeetTheTeam1.png';
import melissa from './imgs/MeetTheTeam2.png';
import mary from './imgs/MeetTheTeam3.png';
import eric from './imgs/MeetTheTeam4.png';
import streamNow from './imgs/MissionAndWelcomeGraphic.png';
import cathy from './imgs/MeetTheTeam5.png';
import dave from './imgs/MeetTheTeam6.png';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import classNames from 'classnames';
import css from './AboutUs.module.css';
const team = [
  { name: 'Colleen Wilson', deg: 'Founder & CEO', key: 'coleen', img: coleenImg },
  { name: 'Melissa Curtis', deg: 'Chief Operations Officer', key: 'melissa', img: melissa },
  { name: 'Mary Kate Jankowski', deg: 'Marketing Manager', key: 'mary', img: mary },
  { name: 'Eric Wilson', deg: 'IT Manager', key: 'eric', img: eric },
  { name: 'Cathy Wilson', deg: 'Accounting', key: 'cathy', img: cathy },
  { name: 'Dave Wilson', deg: 'Chief Technology Officer', key: 'dave', img: dave },
];
const AboutUs = () => {
  const [show, setShow] = useState(null);
  //   useEffect(() => {
  //     if (!show) {
  //       const statementP = document.getElementById('statement');
  //       statementP.style.maxHeight = statementP.scrollHeight + 20 + 'px';
  //     }
  //   }, [show]);
  const mainContent = (
    <div className={css.mainContainer}>
      <div className={css.herobanner}>
        <div className={css.heroSection}>
          <div className={css.leftSection}>
            <div className={css.title}>
              <p>About The Animal List</p>
            </div>
            <div className={css.subTitle}>
              Welcome to The Animal List, our marketplace is dedicated to bringing together people
              looking to hire animal talent and those looking to list their animals for hire.
            </div>
          </div>
          <img src={bannerImage} className={css.heroIcon} />
        </div>
      </div>
      <div className={`${css.sections} ${css.popularSearchContainer}`}>
        <div>
          <p className={css.bodhead}>Revolutionizing The Animal Talent Industry</p>
          <ul>
            <li>
              <button
                className={classNames(css.accrd, { [css.active]: show === 'statement' })}
                onClick={e => {
                  //   const isIncl = show === 'statement';
                  //   const ansDiv = document.getElementById('statement');
                  setShow('statement');
                  //   if (isIncl) {
                  //     ansDiv.style.maxHeight = null;
                  //   } else {
                  //     ansDiv.style.maxHeight = ansDiv.scrollHeight + 20 + 'px';
                  //   }
                }}
              >
                {show === 'statement' ? <FaMinus /> : <FaPlus />} Mission Statement
              </button>
              {show === 'statement' && (
                <p
                  id="statement"
                  className={classNames(css.ansp, {
                    [css.showans]: show === 'statement',
                    [css.defshow]: !show,
                  })}
                >
                  At The Animal List, we strive to make the world a better place one animal at a
                  time by revolutionizing the animal industry through technology and education.
                </p>
              )}
            </li>
            <li>
              <button
                className={classNames(css.accrd, { [css.active]: show === 'mission' })}
                onClick={e => {
                  //   const isIncl = show === 'mission';
                  //   const ansDiv = document.getElementById('mission');
                  setShow('mission');
                  //   if (isIncl) {
                  //     ansDiv.style.maxHeight = null;
                  //   } else {
                  //     ansDiv.style.maxHeight = ansDiv.scrollHeight + 20 + 'px';
                  //   }
                }}
              >
                {show === 'mission' ? <FaMinus /> : <FaPlus />} Our Mission
              </button>
              {show === 'mission' && (
                <p
                  id="mission"
                  className={classNames(css.ansp, { [css.showans]: show === 'mission' })}
                >
                  At The Animal List, we're on a mission to revolutionize the way animal talent is
                  discovered, booked, and showcased. We believe in celebrating the unique abilities
                  and charisma of our furry, feathered, and scaly friends, while also ensuring their
                  well-being and ethical treatment.
                </p>
              )}
            </li>
            <li>
              <button
                className={classNames(css.accrd, { [css.active]: show === 'values' })}
                onClick={e => {
                  //   const isIncl = show === 'values';
                  //   const ansDiv = document.getElementById('values');
                  setShow('values');
                  //   if (isIncl) {
                  //     ansDiv.style.maxHeight = null;
                  //   } else {
                  //     ansDiv.style.maxHeight = ansDiv.scrollHeight + 20 + 'px';
                  //   }
                }}
              >
                {show === 'values' ? <FaMinus /> : <FaPlus />} Our Values
              </button>
              {show === 'values' && (
                <p
                  id="values"
                  className={classNames(css.ansp, { [css.showans]: show === 'values' })}
                >
                  Transparency, trust, and ethical treatment of animals are fundamental values at
                  The Animal List. We uphold strict guidelines to ensure the safety, well-being, and
                  fair treatment of all animal performers showcased on our platform. We're committed
                  to fostering a community of integrity, professionalism, and respect for animals.
                </p>
              )}
            </li>
          </ul>
        </div>
        <div className={css.popimgcont}>
          <img src={missionImage} alt="AboutUs" />
        </div>
        <img src={streamNow} className={css.streamNow} />
      </div>
      <div className={`${css.sections} ${css.coleenContainer}`}>
        <div>
          <img src={coleen} alt="AboutUs" />
        </div>
        <div>
          <p className={css.bodhead}>Welcome To The Animal List!</p>
          <p>
            <p>
              Hi! I'm Colleen Wilson, founder and CEO of Pets on Q and The Animal List. Over the
              past decade, I've witnessed the evolution of the animal talent industry and recognized
              the need for change.
            </p>
            <p>
              Motivated by my passion for animals, I created The Animal List—a marketplace
              simplifying the process of finding vetted animal talent while promoting transparency.
              Inspired by my journey with Charlie, a deaf dog I adopted in 2014, who became a
              therapy dog and influencer, I'm committed to redefining the industry.
            </p>
            <p>
              At Pets on Q, we prioritize the ethical treatment of animals and strive to foster
              trust between the entertainment industry and animals. Join us in celebrating and
              elevating animal talent!
            </p>
          </p>
          <p className={css.colsign}>Colleen Wilson</p>
        </div>
      </div>
      <div className={`${css.sections} ${css.teamContainer}`}>
        <p>Meet Our Team</p>
        <div className={css.teammem}>
          {team.map(m => (
            <div className={css.mem}>
              <img alt={m.key} src={m.img} />
              <p>{m.name}</p>
              <p>{m.deg}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
  return (
    <Page>
      <TopbarContainer />
      {/* <LayoutSingleColumn>{mainContent}</LayoutSingleColumn> */}
      {mainContent}
      <FooterContainer />
    </Page>
  );
};

export default AboutUs;
